<template>
    <div>
        <h2>{{ title }}</h2>
        <section class="vcalender" id="qualifications">            
            <div class="qualification-item" v-bind:key="item.topic" v-for="item in json">
                <h3>{{item.topic}}</h3>
                <div class="quals">
                    <ul v-bind:key="q" v-for="q in item.items">
                        <li>{{q}}</li>                        
                    </ul>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "Qualifications",
  props: {
    title: String,
    json: Array
  }
};
</script>